import img1 from "../../Assets/images/Video.webp";
import img2 from "../../Assets/images/Video2.webp";
import img3 from "../../Assets/images/Video3.webp";
import img4 from "../../Assets/images/Video4.webp";
import profile from "../../Assets/images/creator1.png";
import green from "../../Assets/images/greenSquare.svg";

const CurrentBidData = [
  {
    id: 1,
    headimg: img1,
    name: "Marco carrillo®",
    creatorProfile: profile,
    creatorName: "Enrico Cole",
    EthImg: green,
    ETHPrice: 3.5,
    CurrentBidETH: "1.00",
    Dollar: 3618.6,
    endDate: "March 20, 2023",
  },
  {
    id: 2,
    headimg: img2,
    name: "Marco carrillo®",
    creatorProfile: profile,
    creatorName: "Enrico Cole",
    EthImg: green,
    ETHPrice: 3.5,
    CurrentBidETH: "1.00",
    Dollar: 3618.6,
    endDate: "March 21, 2023",
  },
  {
    id: 3,
    headimg: img3,
    name: "Marco carrillo®",
    creatorProfile: profile,
    creatorName: "Enrico Cole",
    EthImg: green,
    ETHPrice: 3.5,
    CurrentBidETH: "1.00",
    Dollar: 3618.6,
    endDate: "March 22, 2023",
  },
  {
    id: 4,
    headimg: img4,
    name: "Marco carrillo®",
    creatorProfile: profile,
    creatorName: "Enrico Cole",
    EthImg: green,
    ETHPrice: 3.5,
    CurrentBidETH: "1.00",
    Dollar: 3618.6,
    endDate: "March 23, 2023",
  },
];

export default CurrentBidData;
